import { Save, VpnKeySharp, WhatsApp, Phone } from '@mui/icons-material';
import { Box, Button, LinearProgress, useMediaQuery, useTheme, List, ListItemButton, ListItemIcon, ListItemText, Divider, Typography, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterPanel, Modal, Banner, SelectCustom } from '../../components';
import MobileArticles from '../../components/Table/Mobile/Articles';
import { OPERATION } from '../../helpers/enums';
import ArticuloService from '../../services/articulos';
import CategoriaService from '../../services/categorias';

const our = [{
    name: "Mary",
    cel: "5493884760970"
}, {
    name: "Susy",
    cel: "5493874071276"
}, {
    name: "Diego",
    cel: "5493814124209"
}];


const Articles = ({ store, setOptions, setChildHeader }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [loadingArticulos, setLoadingArticulos] = useState(false);
    const [articulos, setArticulos] = useState([]);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [rangePrices, setRangePrices] = useState({ minPrice: Infinity, maxPrice: -Infinity });
    const [filterValues, setFilterValues] = useState({ name: '', category: '', rangePrices: [rangePrices?.minPrice, rangePrices?.maxPrice] });
    const [openModal, setOpenModal] = useState(false);
    const [articleSelected, setArticleSelected] = useState(null);

    const toggleDrawer = (open) => () => {
        setIsFilterOpen(open);
    };

    const loadArticulos = async () => {
        setLoadingArticulos(true)
        var resp = await ArticuloService.getAllArticlesInStoreTo(store._id, OPERATION.VENDER, true, 1)
        // if (!resp || (resp && resp.length === 0))
        //     setArticleInCart([])
        setArticulos(resp);
        // Usamos reduce para encontrar el mínimo y máximo en una sola pasada
        const range = resp?.reduce(
            (acc, item) => ({
                minPrice: Math.min(acc.minPrice, item.prices.sale_price),
                maxPrice: Math.max(acc.maxPrice, item.prices.sale_price),
            }),
            { minPrice: Infinity, maxPrice: -Infinity }
        );
        setRangePrices(range)
        setFilterValues({ name: '', category: '', rangePrices: [range?.minPrice, range?.maxPrice] })
        // getMovementsDineroDisponible()
        // setLoadsArticulos(false)
        setIsFilterOpen(false)
        setLoadingArticulos(false)
    }

    const loadArticulos2 = async (page) => {
        console.log("cargaaa")
        var resp = await ArticuloService.getAllArticlesInStoreTo(store._id, OPERATION.VENDER, true, page, isMobile ? 20 : 50)
        setLoadingArticulos(false)
        return resp
        // if (resp.length > 0)
        //   setArticulos((prevArticulos) => [...prevArticulos, ...resp]);
        //setPage(page + 1)
    }

    const loadCategories = async () => {
        var resp = await CategoriaService.getAll()
        setCategories(resp)
    }

    useEffect(() => {
        if (store) {
            loadCategories()
            loadArticulos()
        }
    }, [store])

    useEffect(() => {
        setChildHeader && setChildHeader(<FilterPanel
            open={isFilterOpen}
            toggleDrawer={toggleDrawer}
            categories={categories}
            filterValues={filterValues}
            onClear={() => setFilterValues({ name: '', category: '', rangePrices: [rangePrices.minPrice, rangePrices.maxPrice] })}
            onApply={handleApplyFilters}
        />)
    }, [articulos])

    useEffect(() => {
        setOptions && setOptions([{
            id: 'login', Icon: () =>
                <Button size='small' onClick={() => navigate("/login")} startIcon={<VpnKeySharp />}>
                    Iniciar Sesion
                </Button>
        }])
    }, [])

    const handleApplyFilters = async ({ name, category, rangePrices }) => {
        setLoadingArticulos(true)
        const params = new URLSearchParams({
            name: name,
            to: OPERATION.VENDER,
            onlyStock: true,
            category: category,
            rangePrices: rangePrices
        })
        var resp = await ArticuloService.searchArticlesInStore2(store._id, params)
        console.log(resp)
        setArticulos(resp)
        setLoadingArticulos(false)
    }

    const sendWhatsAppMessage = (article) => {
        setArticleSelected(article)
        setOpenModal(true)
    };

    const handleEnviarMensaje = (message, indexImage, number) => {
        //const phoneNumber = '5493814124209'; // Número de WhatsApp en formato internacional
        const fullMessage = `${message}\n\n\nImagen: ${articleSelected?.images[indexImage]}`;
        const url = `https://wa.me/${number}?text=${encodeURIComponent(fullMessage)}`;

        setOpenModal(false)
        window.open(url, '_blank'); // Abre WhatsApp en una nueva pestaña
    }

    const SelectNumber = () => {
        const [message, setMessage] = useState("");
        const [indexImage, setIndexImage] = useState(0);
        const [number, setNumber] = useState([]);

        const onHandleImageChange = (index) => {
            setIndexImage(index)
        }

        const onHandleOptionSelected = (value) => {
            const n = our.find(o => o.name === value)?.cel;
            setNumber(n)
        }

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', p: 0, m: 0, bgcolor: 'background.paper', background: '#f2e8e4' }}>
                <Box p={1}>
                    <Typography variant='h5' >{articleSelected.name}</Typography>
                    <Typography variant='body2' textAlign={'justify'}>{articleSelected.description}</Typography>
                </Box>
                <Banner images={articleSelected.images} onlyImages auto={false} onImageChange={onHandleImageChange} />
                <SelectCustom options={our} onOptionSelected={onHandleOptionSelected} />
                <Divider />
                <TextField
                    id="description"
                    label="Mensaje"
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                    multiline
                    maxRows={5}
                    sx={{ marginY: 1 }}
                />
                {/* <Button variant="outlined" onClick={() => handleEnviarMensaje(getNumero(selectedIndex))}>
                    Enviar mensaje
                </Button> */}
                <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Button
                        color='error'
                        onClick={() => setOpenModal(false)}
                    >Cancelar</Button>
                    <Button
                        disabled={number === '' || message === ''}
                        color={'success'}
                        onClick={() => handleEnviarMensaje(message, indexImage, number)}
                    //disabled={!isValid}
                    >Enviar mensaje</Button>
                </Box>
            </Box>
        )
    }

    return (<>
        {loadingArticulos && <LinearProgress color='secondary' />}
        <Box display='flex' minHeight='100%' maxWidth='100%' flexDirection={'column'}>
            <Box display='flex' flexDirection='row' flexWrap="wrap" flex='1'>
                {!loadingArticulos && articulos &&
                    <MobileArticles
                        readOnly
                        asList={false}
                        onSendMessage={sendWhatsAppMessage}
                        fetchArticles={loadArticulos2}
                        loadLizy
                    />
                }
            </Box>
            <Modal
                open={openModal}
                onClose={setOpenModal}
                Content={SelectNumber}
            />
        </Box>
    </>);
}

export default Articles;